import { Component, EventEmitter, Input, Output } from '@angular/core'
import { IconNamesEnum } from 'ngx-bootstrap-icons'
import { Dictionary } from '../filtering-search-component-base/filtering-search-types'
import { DocumentLinksComponent } from '../document-links/document-links.component'
import { SafeHtmlPipe } from '../../pipes/safehtml.pipe'
import { NgTemplateOutlet } from '@angular/common'
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons'
import { AdobePDFViewerComponent } from '../adobe-pdf-viewer/adobe-pdf-viewer'
import { CalendarEntry } from 'src/app/pages/data/calendar/calendar-article.model'
import { expandCollapse, openClose } from '../../animations/open-close-animations'

@Component({
    animations: [
        openClose,
        expandCollapse,
    ],
    selector: 'app-calendar-event-body',
    imports: [
        AdobePDFViewerComponent,
        NgxBootstrapIconsModule,
        NgTemplateOutlet,
        SafeHtmlPipe,
        DocumentLinksComponent
    ],
    templateUrl: './calendar-event-body.component.html',
    styleUrl: './calendar-event-body.component.scss'
})
export class CalendarEventBodyComponent {
  @Input() entry : CalendarEntry | undefined
  @Output() purchased = new EventEmitter<boolean>

  public isExpanded: Dictionary<boolean> = {}
  public iconNames = IconNamesEnum

  documentPurchased() {
    this.purchased.next(true)
  }
  hearingDescription(hearingType:string, hearingDetails:string): string {
    let result = ''
    if (hearingType.length > 0) {
      result = `<p>${hearingType}:&nbsp;</p>`
    }
    return result + hearingDetails
  }
}
